import { trackApplicationEvent } from 'tracking/application/trackApplicationEvent';

export const trackApplication = trackApplicationEvent('REGISTER_PROSPECT');
